module.exports = "/video-roulette/img/brown-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/brown-ball.png
// module id = 2441
// module chunks = 10